import { FeatureFlagName, RemoteFlagName } from '../constants/features';
import { createInitializer } from '../utilities/initializer';

export type FeatureFlagStatus = {
    [key: string]: boolean;
};

export type RemoteFlagsSet = { [key in RemoteFlagName]: boolean };

export const RemoteFlagsSet = createInitializer<RemoteFlagsSet>({
    ExampleFlag: false, // This is an example flag, not being used today. Future flags can be added here
});

export type FeatureFlagSet = { [key in FeatureFlagName]: boolean };

export const FeatureFlagSet = createInitializer<FeatureFlagSet>({
    EnableBetaDataPlane: false,
    UnderDevelopment: false,
    UseNonPreauthorizedScopes: false,
    LogVerbose: false,
    EnableThemeModeToggle: false,
    SingleDevCenterMode: false,
    DisplayNames: false,
    RoundTripTime: false,
    EnableDiscoveryService: false,
    EnableIntrinsicTasksForCustomization: false,
    EnableGuestUser: false,
    EnableConnectWithVSCode: false,
});
